(() => {
  const adultNum = '.camping-adult-num';
  const kidsNum = '.camping-kids-num';

  const init = () => {
    $('body').on('change', { adultNum, kidsNum }, showCampingSubscriptionWord);
  }

  const showCampingSubscriptionWord = e => {
    const totalNum = parseInt($(adultNum).val()) + parseInt($(kidsNum).val());
    if (totalNum > 1) {
      $('.info_for_one_camping_subscriber').hide();
      $('.info_for_more_than_two_including_camping_subscriber').show();
    } else {
      $('.info_for_one_camping_subscriber').show();
      $('.info_for_more_than_two_including_camping_subscriber').hide();
    }
  }
  $(init)
})();
